import BooleanWithLabel from "@/Components/Boolean/BooleanWithLabel";
import useCountryConfigHook from "@/shared/hooks/useCountryConfigHook";
import { cn } from "@/shared/utils/cn";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Is18PlusWebsite = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();
  const { isTurkiye } = useCountryConfigHook();

  return (
    <div className={cn("my-[2rem]", isTurkiye ? "hidden" : "block")}>
      <Controller
        name="is18PlusWebsite"
        control={control}
        render={({ value, onChange }) => (
          <BooleanWithLabel checked={value} onChange={() => onChange(!value)}>
            {t("is18PlusWebsite")}
          </BooleanWithLabel>
        )}
      />
    </div>
  );
};

export default Is18PlusWebsite;
